import http from "@/service";
import cache from "@/utils/cache";
import { VERSION } from "@/global/constant";

export const useUpdateVersionAndReload = () => {
  const timeStamp = new Date().getTime();
  const url = `//${window.location.host}/version.json?t=${timeStamp}`;
  http.get(url).then((res: any) => {
    if (res) {
      const appVersion = res.version;
      const localAppVersion = cache.getCache(VERSION);
      if (localAppVersion && localAppVersion !== appVersion) {
        console.log("发现新版本,自动更新中...", appVersion);
        cache.setCache(VERSION, appVersion);
        window.location.reload();
        return;
      } else {
        cache.setCache(VERSION, appVersion);
      }
    }
  });
};
